import React, { Component } from 'react';
import wpStyles from '../../wordpressStyles';


class RoundedContainer extends React.Component {
    render() {
        const xPadding = typeof(this.props.xPadding) != "undefined" ? 'px-' + this.props.xPadding : 'px-8';
        const yPadding = typeof(this.props.yPadding) != "undefined" ? 'py-' + this.props.yPadding : 'py-4';

        return (
            <div
                className={
                    'flex flex-col lg:flex-row w-full bg-gray-500 rounded-huge overflow-hidden '+xPadding+' '+yPadding+' ' + this.props.className
                }
                style={wpStyles.backgroundColor3}
            >
                {this.props.children}
            </div>
        );
    }
}

export default RoundedContainer;
